<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid login-orders-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Logins & Orders Report</h4>
            <hr style="margin-bottom: 0; "/>
            <loginsAndOrdersReportForm></loginsAndOrdersReportForm>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import LoginsAndOrdersReportForm from "@/views/admin/reports/loginsAndOrdersReport/LoginsAndOrdersReportForm.vue";


export default {
  name: "LoginsAndOrdersReport",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    loginsAndOrdersReportForm: LoginsAndOrdersReportForm,
  },

  data() {
    return {};
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "reportsLogins&OrdersReport",
        activeMenu: this.activeMenu ? this.activeMenu : "reports",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.login-orders-report {
//   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

html,
body {
  height: 100%;
}
</style>
